import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { changeLocale } from '@app/actions/global'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Loader from '@app/components/ui/placeholders/Loader'
import styled from 'styled-components'

export const Frame = styled.iframe`
  transform: ${props => `scale(${props.ratio})`};
  width: ${props => `${100 / props.ratio}%`};
  height: ${props => `${100 / props.ratio}%`};
  transform-origin: 0 0;
`

class Player extends Component {
  constructor(props) {
    super(props);

    this.state = { loading: true, scale: 1.0 }

    this._suppressTimer = null

    this.frameMessage = this.frameMessage.bind(this)
    this.frameLoad = this.frameLoad.bind(this)

    this.handleResize = this.handleResize.bind(this)
    this.handleWindowResize = this.handleWindowResize.bind(this)
  }

  get dimensions() {
    return this.props.mode == 'card' ? [1024, 620] : [620, 250];
  }

  get frame() {
    return this.refs.frame
  }

  componentDidMount() {
    window.addEventListener("message", this.frameMessage)
    window.addEventListener("resize", this.handleWindowResize)
    window.addEventListener("orientationchange", this.handleWindowResize, false)
    this.frame.addEventListener("load", this.frameLoad)

    if (window.COUNTRY === 'RU' && document.getElementById("usedesk-messenger")) {
      document.getElementById("usedesk-messenger").style.display = "none";
    } else {
      try { zE('webWidget', 'hide'); }
      catch (e) { console.error(e); }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.frameMessage)
    window.removeEventListener("resize", this.handleWindowResize)
    window.removeEventListener("orientationchange", this.handleWindowResize)

    if (this._cleanupClickSuppression) {
      if (this._suppressTimer) {
        // allow timer to remove the handlers
      } else {
        this._cleanupClickSuppression()
      }
    }

    if (window.COUNTRY === 'RU' && document.getElementById("usedesk-messenger")) {
      document.getElementById("usedesk-messenger").style.display = "block";
    } else {
      try { zE('webWidget', 'show'); }
      catch (e) { console.error(e); }
    }
  }

  // Дизейблим все клики на 500мс после закрытия плеера с карточкой,
  // чтобы избежать ложных срабатываний кнопки "назад" в олимпиаде,
  // так как обе кнопки назад расположены одна под другой.
  suppressNextParentClick() {
    const stop = (e) => {
      e.preventDefault()
      e.stopPropagation()
    }

    const cleanup = () => {
      document.removeEventListener('click', stop, true)
      document.removeEventListener('mousedown', stop, true)
      document.removeEventListener('mouseup', stop, true)
      this._cleanupClickSuppression = null
      if (this._suppressTimer) { clearTimeout(this._suppressTimer); this._suppressTimer = null }
    }

    document.addEventListener('click', stop, true)
    document.addEventListener('mousedown', stop, true)
    document.addEventListener('mouseup', stop, true)

    this._suppressTimer = setTimeout(() => cleanup(), 500)
    this._cleanupClickSuppression = cleanup
  }

  frameMessage(message) {
    // Gambit's default events module prefixes every event with "player.".
    switch (message.data && message.data.type) {
      case "player.back":
        const { onBack } = this.props

        this.suppressNextParentClick()

        const payload = this.normalizeBackPayload(message.data.payload)

        if (onBack) { onBack(payload) }
        else { window.location.replace('/') }

        break;
      case "player.changeLocale":
        const { boundedChanger } = this.props
        boundedChanger(message.data.payload)

        break;
      default:
        console.log("Received message from card:", message)
    }
  }

  normalizeBackPayload(payload) {
    if (payload && typeof payload === 'object' && Object.keys(payload).length === 0) {
      return undefined
    }

    return payload
  }

  handleWindowResize() {
    this.handleResize()
  }

  postMessage(message) {
    this.frame.contentWindow.postMessage(message, "*")
  }

  frameLoad() {
    this.setState({ ...this.state, loading: false })
    this.FatPlayer = new UCHI.FatPlayer()

    var win = this.frame.contentWindow || this.frame
    this.FatPlayer.contentWindow = win;

    if (win.FatPlayer && win.FatPlayer.MessageTunnel) {
      win.FatPlayer.MessageTunnel.setListener(
        win, "FatPlayer.cardResize", this.handleResize
      )

      this.handleResize()
    }

    win.focus()
  }

  handleResize() {
    const t = this
    const frame = this.frame

    // Let the card to adoptate
    this.scaleTo(1)
    this.forceUpdate()

    this.FatPlayer.getBodyScrollHeight((_, scrollHeight) => {
      t.scaleTo(scrollHeight)
    })
  }

  scaleTo(scrollHeight) {
    const container = this.frame.parentNode
    const scale = Math.min.apply(Math, [
      container.clientWidth / this.dimensions[0],
      container.clientHeight / scrollHeight
    ])

    this.setScale(scale >= 1 ? 1 : scale)
  }

  setScale(ratio) {
    this.setState(() => { return { ...this.state, scale: ratio } })
  }

  render() {
    let { src } = this.props
    let { loading, scale } = this.state

    let classes = classnames(
      "card-player__frame"
    );

    return (
      <div className="card-player">
        {loading ? <Loader /> : null}

        <div className="card-player__wrapper">
          <Frame
            className={classes}
            src={src}
            ref="frame"
            scrolling="no"
            ratio={scale || 1}
          />
        </div>
      </div>
    )
  }
}

Player.propTypes = {
  src: PropTypes.string.isRequired
};

Player.defaultProps = {
  mode: 'card'
};

const mapDispatchToProps = (dispatch) => {
  const boundedChanger = bindActionCreators(changeLocale, dispatch)
  return { boundedChanger }
}

export default connect(null, mapDispatchToProps)(Player)
